export default __webpack_public_path__ + "static/media/background-video.2449866e.mp4";